import type { MutationResult } from '@apollo/react-common';
import { useMutation } from '@apollo/react-hooks';
import gqlTagSwag from 'graphql-tag';
import type { UnassignEpicMutationResponse, UnassignEpic } from './types.tsx';

export const UNASSIGN_EPIC_MUTATION = gqlTagSwag`mutation BacklogissueParentUnassign(
        $boardId: ID!,
        $issueIds: [ID!]!
    ) {
        unassignIssueParent(input: { boardId: $boardId, issueIds: $issueIds }) {
            success
        }
    }`;

export const useUnassignEpicMutation = (
	boardId: number,
): [UnassignEpic, MutationResult<UnassignEpicMutationResponse>] => {
	const [mutate, epicAssigningMutationData] = useMutation(UNASSIGN_EPIC_MUTATION);
	const unassignEpic: UnassignEpic = (issues) =>
		mutate({
			variables: {
				boardId,
				issueIds: issues.map(({ id }) => id),
			},
		});

	return [unassignEpic, epicAssigningMutationData];
};
